//@ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('contacts.roles.role', {
        url: '/{roleId}',
        views: {
            "contactView@contacts": {
                templateUrl: 'main/contacts/roles/role/role.tpl.html',
                controller: 'RoleController as vm'
            }
        },
        resolve: {
            role: roleResolver,
            claims: claimsResolver,
            widgets: widgetsResolver,
            dataSources: dataSourcesResolver
        }
    });
}

//@ngInject
function roleResolver(RolesApiService, $stateParams) {
    return RolesApiService.getRole($stateParams.roleId);
}

//@ngInject
function claimsResolver(RolesApiService) {
    return RolesApiService.getAllClaims();
}

//@ngInject
function widgetsResolver(RolesApiService) {
    return RolesApiService.getAllWidgets();
}

//@ngInject
function dataSourcesResolver(RolesApiService) {
    return RolesApiService.getAllDataSources();
}

//@ngInject
function RoleController($translate, $scope, AuthService, role, claims, RolesApiService, loadSpinnerService, widgets, dataSources) {
    var vm = this;

    vm.role = role;
    vm.claims = claims;

    vm.objectTypes = [];
    vm.claimsRowData = [];
    vm.claimTypes = [];

    vm.saveRole = saveRole;
    vm.canAccess = AuthService.canAccess;
    vm.widgets = widgets;
    vm.dataSources = dataSources;

    activate();

    function activate() {
        _.forEach(vm.claims, function(claim) {
            if (!_.find(vm.claimTypes, function(claimType) { return claimType === claim.claimType; })) {
                vm.claimTypes.push(claim.claimType);
            }
            if (!_.find(vm.objectTypes, function(objectType) { return objectType === claim.objectType; })) {
                vm.objectTypes.push(claim.objectType);
            }
        });

        loadClaimsGridData();
    }

    function saveRole() {
        var claimsToSave = [];
        _.forEach(vm.claimsRowData, function(rowData) {
            var objectType = rowData["rowHeaderSystemType"];
            var keys = Object.keys(rowData);

            keys = _.without(keys, "rowHeaderSystemType");

            _.forEach(keys, function(claimType) {
                if (rowData[claimType] === true) {
                    var foundClaim = _.find(vm.claims, function(claim) {
                        return claim.objectType === objectType && claim.claimType === claimType;
                    });
                    claimsToSave.push(foundClaim);
                }
            });
        });

        vm.role.claims = claimsToSave;

        loadSpinnerService.start('mainSpinner');
        RolesApiService.updateRole(vm.role).then(function(response) {

        }, function(error) {
            console.log(error);
        }).finally(function() {
            loadSpinnerService.stop('mainSpinner');
        });
    }


    function loadClaimsGridData() {
        _.forEach(vm.objectTypes, function(objectType) {

            var r = {
                rowHeaderSystemType: objectType,
                rowHeaderLabel: $translate.instant('role.' + objectType)
            };
            _.forEach(vm.claimTypes, function(claimType) {
                if (_.find(vm.role.claims, function(claim) { return claim.claimType === claimType && claim.objectType === objectType; })) {
                    r[claimType] = true;
                } else {
                    r[claimType] = false;
                }
            });
            vm.claimsRowData.push(r);
        });


    }


}


angular.module('contacts.roles.role', [])
    .config(stateConfig)
    .controller('RoleController', RoleController);
